<template>
  <v-card
    class="py-3 px-2"
    outlined
  >
    <v-card-title class="light-blue--text headline justify-space-between"><span class="d-none d-md-block">{{title}}</span> <span class="d-block d-md-none">Reminders</span>

      <v-menu
        offset-y
        left
        close-on-content-click
        transition="scale-transition"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            aria-label="Filter Reminders"
            text
            v-bind="attrs"
            v-on="on">
            <v-icon>mdi-filter-variant</v-icon>
          </v-btn>

        </template>

        <v-list>
          <v-list-item :class="(filterMode === 'active') ? 'light-blue lighten-2' : ''" @click="setFilter('active')">
            <v-list-item-title>Active Only</v-list-item-title>
          </v-list-item>
          <v-list-item :class="(filterMode === 'completed') ? 'light-blue lighten-2' : ''" @click="setFilter('completed')">
            <v-list-item-title>Completed Only</v-list-item-title>
          </v-list-item>
          <v-list-item :class="(filterMode === 'all') ? 'light-blue lighten-2' : ''" @click="clearFilter">
            <v-list-item-title>Show All</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-title>
    <v-card-text>

      <template v-if="remindersLoading">
        <div class="text-center">
          <v-progress-circular color="light-blue" indeterminate/>
        </div>
      </template>
      <template v-else>
        <template v-if="Object.keys(filteredReminders).length">
          <template v-for="(reminder, key, index) in filteredReminders">
            <v-row no-gutters :key="reminder+key" align="center" justify="space-between" >
              <v-col cols="12" lg="8" xl="9">
                <div class="d-flex justify-space-between">
                  <div>
                    <v-icon small class="grey--text mr-1">mdi-calendar</v-icon>
                    <span class="font-weight-bold ">{{ reminder.date.toDate() | moment("MM/D/YY") }}</span>
                    <span class="ml-1 success--text" v-if="reminder.complete">(Completed)</span>
                  </div>
                  <span class="d-none">{{ properties[reminder.propertyID].addressLineOne }}</span>
                </div>
                <div :class="editMode ? '' : 'text-truncate' " class="mb-3 mb-lg-0">{{ reminder.text }}</div>
              </v-col>
              <v-col cols="12" lg="auto" v-if="editMode">
                  <v-row>
                    <v-col class="text-center px-0">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="toggleReminderCompletion(key)"
                            :color="reminder.complete ? 'success' : 'grey lighten-2'"
                            icon
                            text
                            aria-label="Toggle completion"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>{{ `mdi-check-${reminder.complete ? 'bold' : 'outline'}` }}</v-icon>
                          </v-btn>
                        </template>
                        <span>{{`Mark as ${reminder.complete ? 'incomplete' : 'complete'}.`}}</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            icon text
                            aria-label="Edit Reminder"
                            :to="'/reminders/'+key"
                            :disabled="(key === reminderID)"
                          >
                            <v-icon>mdi-pencil-box-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Edit</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="error"
                            v-bind="attrs"
                            type="button"
                            v-on="on"
                            icon text
                            aria-label="Delete Reminder"
                            @click="deleteItem(key)"
                          >
                            <v-icon>mdi-delete-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Delete</span>
                      </v-tooltip>

                    </v-col>
                  </v-row>
              </v-col>
              <v-col cols="12" lg="3" xl="2" v-else>
                <v-btn
                  color="light-blue"
                  dark
                  block
                  :small="$vuetify.breakpoint.mdAndUp"
                  elevation="0"
                  tile
                  :to="'/reminders/'+key"
                >
                  View
                </v-btn>

              </v-col>
            </v-row>
            <v-divider v-if="index !== Object.keys(filteredReminders).length -1" class="my-3" :key="key+'-list-divider'"></v-divider>
          </template>
        </template>
        <template v-else>
          <v-row align="center" justify="space-between">
            <v-col>
              There are no reminders to display.
            </v-col>
          </v-row>
        </template>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";

  export default {
    name: "RemindersList",
    data: () => ({
      filterMode: 'all',
      filterActive: false,
    }),
    created(){
      if (this.$props.filter !== 'all'){
        this.setFilter(this.$props.filter)
      }
    },
    computed:{
      filterType(){
        return (this.filterMode === 'completed');
      },
      filteredReminders(){
        let filteredObject = {};
        let result = Object.keys(this.reminders);
        if (this.propertyID !== null){
          result.forEach((item) => {
            if (this.reminders[item].propertyID === this.propertyID){
              if ((this.filterActive && this.reminders[item].complete === this.filterType) || (!this.filterActive)){
                filteredObject[item] = this.reminders[item];
              }
            }
          });
        } else {
          result.forEach((item) => {
            if ((this.filterActive && this.reminders[item].complete === this.filterType) || (!this.filterActive)){
              filteredObject[item] = this.reminders[item];
            }
          });
        }
        return filteredObject;

      },
      ...mapGetters(['reminders', 'reminderID', 'remindersLoading','properties', 'propertyID']),
    },

    props: {
      editMode: {
        type: Boolean,
        default: false
      },
      filter: {
        type: String,
        default: 'all',
      },
      title: {
        type: String,
        default: 'Reminders'
      }
    },
    methods: {
      setFilter(mode){
        this.filterMode = mode;
        this.filterActive = true;
      },
      clearFilter(){
        this.filterMode = 'all';
        this.filterActive = false;
      },
      async deleteItem(id) {
        await this.deleteReminder(id);
      },

      ...mapActions([
        'toggleReminderCompletion',
        'deleteReminder',
      ]),

    },
  }
</script>

<style scoped>

</style>